import '@hapana/shared/utils/type-defs.util'

/** @type { Styles } */

export const getBannerStyles = (colors) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 2,
    width: '100%',
    padding: (theme) => theme.spacing(0.75, 2),
    backgroundColor: colors.bg,
    flexWrap: 'wrap',
  },
  message: {
    fontSize: '14px',
    fontWeight: 500,
    color: colors.text,
    textAlign: 'center',
  },
  actionButton: {
    fontSize: '14px',
    fontWeight: 700,
    color: colors.text,
    textDecoration: 'underline',
    whiteSpace: 'nowrap',
    display: 'flex',
    alignItems: 'center',
    gap: 0.5,
    border: 'none',
    background: 'none',
    padding: 0,
    cursor: 'pointer',
    '&:hover': { opacity: 0.8 },
  },
  spinner: {
    color: colors.text,
  },
})
